import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"com-pc-card"},[[_c(VRow,{staticClass:"com-pc-card-contents pl-3 py-0"},[_c(VCol,{staticClass:"rp-twninfo py-2"},[_vm._v(_vm._s(_vm.address))]),_c('div',{staticClass:"rp-btn pr-1"},[_c(VBtn,{staticClass:"rp-btn mr-2",attrs:{"outlined":"","small":"","color":"success"},on:{"click":_vm.openTwninfo}},[_c('span',[_vm._v(_vm._s(_vm.text.btn))])])],1)],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }